document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-see-all')
  if (!btn) return

  e.preventDefault()
  e.stopPropagation()

  const submitBtn = document.querySelector(
    'form.search-bar--modal button[type="submit"][data-search-bar-submit]'
  )

  if (!submitBtn) return

  submitBtn.click()
})
